import { render } from "./Literacy.vue?vue&type=template&id=3498a648"
import script from "./Literacy.vue?vue&type=script&lang=js"
export * from "./Literacy.vue?vue&type=script&lang=js"
script.render = render

export default script